import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { useIsConvelioSupplier } from 'src/app/hooks/useIsConvelioSupplier';

import { translations } from '../../../../../../locales/translations';
import MerchandiseDivider from './MerchandiseDivider';

type Props = {
  estimations: string;
};

/**
 * "Algorithm Packing estimations" section, shown on a packing booking detail.
 * Internal Convelio supplier teams (Le Bourget / Heathrow) only.
 */
const MerchandisePackingEstimations = ({
  estimations
}: Props): JSX.Element | null => {
  const { t } = useTranslation();
  const isConvelioSupplier = useIsConvelioSupplier();
  const title = t(
    translations.pages.booking.features.merchandise.packingEstimations
  );

  if (!isConvelioSupplier) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '1rem'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingBottom: '0.5rem'
          }}
        >
          <Typography
            sx={{
              lineHeight: '1.36rem',
              fontWeight: 600,
              color: `grey.500`,
              textAlign: 'left'
            }}
          >
            {title}
          </Typography>
        </Box>
        <Typography
          data-testid="merchandise-packing-estimations"
          whiteSpace="pre-line"
          sx={{
            fontSize: '0.875rem',
            lineHeight: '1.36rem',
            color: 'grey.500',
            wordWrap: 'break-word'
          }}
        >
          {estimations}
        </Typography>
      </Box>
      <MerchandiseDivider />
    </>
  );
};

export default MerchandisePackingEstimations;
